import axios from "axios"

export default {
  getAdAccountSmartAudienceDrafts(adAccount) {
    const url = `/fam/adaccounts/${adAccount}/smart-audiences-drafts`

    return axios.get(url).then(response => {
      return response.data
    })
  },

  getAdAccountSmartAudienceDraft(id) {
    const url = `/fam/smart-audiences-drafts/${id}`

    return axios.get(url).then(response => {
      return response.data
    })
  },

  postAdAccountSmartAudienceDraft(adAccount, data) {
    const url = `/fam/adaccounts/${adAccount}/smart-audiences-drafts`

    return axios.post(url, data).then(response => {
      return response.data
    })
  },

  patchAdAccountSmartAudienceDraft(id, data) {
    const url = `/fam/smart-audiences-drafts/${id}`

    return axios.patch(url, data).then(response => {
      return response.data
    })
  },

  publishSmartAudienceDraft(draftId) {
    const url = `/fam/smart-audiences-drafts/${draftId}/publish`

    return axios.post(url).then(response => {
      return response.data
    })
  },

  deleteSmartAudienceDraft(draftId) {
    const url = `/fam/smart-audiences-drafts/${draftId}`

    return axios.delete(url).then(response => {
      return response.data
    })
  },
}
